import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { fetchProductDetails } from '../../redux/actions/productActions'
import { updateCart, addProductToCart } from '../../redux/actions/cartActions'
import { addFavourite, removeFavourite, listFavouriteIds } from '../../redux/actions/favouriteActions'
import { Gallery } from './components'
import styles from '../../sass/product.module.scss'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import { OLD_API_BASE_URL } from '../../constant'
import ProductCard from '../../components/ProductCard'

const ProductDetails = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  // Fetch product details from Redux store
  const { product, loader, errors } = useSelector((state) => state.products);
  const { cart } = useSelector((state) => state.cart);
  const { favouriteIds } = useSelector((state) => state.favourites);
  const { token, userDetails } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const cleanSlug = slug.replace(/\.html$/, '');

  useEffect(() => {
    if (slug) {
      dispatch(fetchProductDetails(cleanSlug));
    }
  }, [slug, dispatch]);  // Re-fetch data if the slug changes

  useEffect(() => {
    if (userDetails?.id) {
      dispatch(listFavouriteIds());
    }
  }, [dispatch, userDetails]);

  const discount = getDiscountPercentage(product.regular_price, product.sale_price);
  const lowestPrice = getLowestSalePrice(product.pro_var); 

  // Retrieve user_id from local storage or generate a guest ID
  const [userId, setUserId] = useState('');
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [selectedVariations, setSelectedVariations] = useState([]);
  const [isPriceRequestOpen, setIsPriceRequestOpen] = useState(false);
  let variationLengh = selectedVariations.length;

  // Product Tabs: active tab state
  const [activeTab, setActiveTab] = useState(0);

  // Function to add selected variation to state
  const addVariationToSelected = (productNQty) => {
    setSelectedVariations((prevVariations) => {
        const productIndex = prevVariations.findIndex(
            (product) => product.id === productNQty.id
        );

        console.log("productIndex", productIndex)

        if (productIndex !== -1) {
            // Product exists, update only the quantity
            const updatedVariations = [...prevVariations];
            updatedVariations[productIndex].quantity = productNQty.quantity; // Replace the quantity
            return updatedVariations;
        } else {
            // Product does not exist, add it to the list
            return [...prevVariations, productNQty];
        }
    });
  };

  useEffect(() => {
    const initializeUserId = async () => {
      let storedUserId = await localStorage.getItem('user_id');
      if (!storedUserId) {
        storedUserId = `guest-${Math.random().toString(36).substr(2, 9)}`;
        await localStorage.setItem('user_id', storedUserId);
      }
      setUserId(storedUserId);
    };

    initializeUserId();
  }, []);

  useEffect(() => {
    if (isPriceRequestOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isPriceRequestOpen]);


  const handleQuantityChange = (newQuantity) => {
    setSelectedQuantity(newQuantity)
    console.log('Selected Quantity:', newQuantity);
  };


  const handleAddToCartOLD = () => {
    console.log('Attempting to add product to cart.');
    console.log("Selected Variation list here:", selectedVariations);

    if (product?.pro_var?.length > 0) {
        // Loop through selected variations and add/update them in the cart
        const updatedCart = { ...cart, products: [...((cart && cart.products) || [])] }; // Clone the cart and products array

        selectedVariations.forEach((variation) => {
            const discountedTotalPerItem = variation.mrp - variation.offer_price;
            const dfee = variation.dfee || 0;

            const newProduct = {
                id: variation.id,
                image: variation.image,
                name: variation.name,
                brand: product.brand?.name || '',
                mrp: variation.mrp,
                offer_price: variation.offer_price,
                stock_status: variation.stock_status,
                cod_status: variation.cod_status,
                quantity: variation.quantity,
                dfee: dfee, // Add dfee for overweight calculation
            };

            const existingProductIndex = updatedCart.products.findIndex(
                (item) => item.id === variation.id
            );

            if (existingProductIndex !== -1) {
                // Update quantity for existing product immutably
                updatedCart.products[existingProductIndex] = {
                    ...updatedCart.products[existingProductIndex],
                    quantity: updatedCart.products[existingProductIndex].quantity + variation.quantity,
                };
            } else {
                // Add new product to cart
                updatedCart.products.push(newProduct);
            }

            // Update cart
            updatedCart.user_id = userId;
            updatedCart.total =
                (updatedCart.total || 0) + variation.quantity * variation.mrp;
            updatedCart.discountedTotal =
                (updatedCart.discountedTotal || 0) + variation.quantity * discountedTotalPerItem;
            updatedCart.totalQuantity =
                (updatedCart.totalQuantity || 0) + variation.quantity;
            updatedCart.overweight_total =
                (updatedCart.overweight_total || 0) + (dfee > 0 ? dfee * variation.quantity : 0); // Calculate overweight_total per quantity
            updatedCart.totalProducts = updatedCart.products.length;
        });

        // Dispatch the updated cart to the store
        dispatch(updateCart(updatedCart))
            .unwrap()
            .then((res) => {
              toast.info('Selected variations added to cart!');
              console.log('Cart updated with variations:', res);
            })
            .catch((err) => {
              toast.error('Failed to add variations to cart.');
                console.error('Error:', err);
            });
    } else if (product && userId) {
        // Handle single product case
        const discountedTotalPerItem = product.regular_price - product.sale_price;
        const dfee = product.dfee || 0;

        const newProduct = {
            id: product.id,
            image: product.thumbnail,
            name: product.title,
            brand: product.brand?.name || '',
            mrp: product.regular_price,
            offer_price: product.sale_price,
            stock_status: product.stock_status,
            cod_status: product.codchk,
            quantity: selectedQuantity,
            dfee: dfee, // Add dfee for overweight calculation
        };

        const currentCart = cart;

        if (!currentCart || !currentCart.products) {
            // Initialize a new cart
            const updatedCart = {
                user_id: userId,
                products: [newProduct],
                total: selectedQuantity * product.regular_price,
                discountedTotal: selectedQuantity * discountedTotalPerItem,
                totalProducts: 1,
                totalQuantity: selectedQuantity,
                overweight_total: dfee > 0 ? dfee * selectedQuantity : 0, // Calculate overweight_total per quantity
            };

            dispatch(addProductToCart(updatedCart))
                .unwrap()
                .then((res) => {
                  toast.success('Product added to cart!');
                  console.log('Cart initialized and updated:', res);
                })
                .catch((err) => {
                  toast.error('Failed to add product to cart.');
                  console.error('Error:', err);
                });
            return;
        }

        const existingProductIndex = currentCart.products.findIndex(
            (item) => item.id === product.id
        );

        if (existingProductIndex !== -1) {
            // Update quantity for existing product immutably
            const updatedCart = {
                ...currentCart,
                products: currentCart.products.map((item, index) =>
                    index === existingProductIndex
                        ? { ...item, quantity: item.quantity + selectedQuantity }
                        : item
                ),
            };

            updatedCart.total = updatedCart.products.reduce(
                (sum, item) => sum + item.quantity * item.mrp,
                0
            );
            updatedCart.discountedTotal = updatedCart.products.reduce(
                (sum, item) => sum + item.quantity * (item.mrp - item.offer_price),
                0
            );
            updatedCart.totalQuantity = updatedCart.products.reduce(
                (sum, item) => sum + item.quantity,
                0
            );
            updatedCart.overweight_total = updatedCart.products.reduce(
                (sum, item) => sum + (item.dfee > 0 ? item.dfee * item.quantity : 0),
                0
            );

            dispatch(updateCart(updatedCart))
                .unwrap()
                .then((res) => {
                  toast.success('Product quantity updated in cart!');
                  console.log('Cart updated:', res);
                })
                .catch((err) => {
                  toast.error('Failed to update product in cart.');
                  console.error('Error:', err);
                });
        } else {
            // Add new product to cart
            const updatedCart = {
                ...currentCart,
                products: [...currentCart.products, newProduct],
                total: currentCart.total + selectedQuantity * product.regular_price,
                discountedTotal:
                    currentCart.discountedTotal +
                    selectedQuantity * discountedTotalPerItem,
                totalProducts: currentCart.totalProducts + 1,
                totalQuantity: currentCart.totalQuantity + selectedQuantity,
                overweight_total: (currentCart.overweight_total || 0) + (dfee > 0 ? dfee * selectedQuantity : 0), // Calculate overweight_total per quantity
            };

            dispatch(addProductToCart(updatedCart))
                .unwrap()
                .then((res) => {
                  toast.success('Product added to cart!');
                  console.log('Cart updated:', res);
                })
                .catch((err) => {
                  toast.error('Failed to add product to cart.');
                  console.error('Error:', err);
                });
        }
    } else {
      toast.error('Unable to add product to cart.');
      console.error('Missing product or userId.');
    }
  };

  const handleAddToCart = () => {
    const cloneCart = () => JSON.parse(JSON.stringify(cart || { products: [] }));

    const calculateTotals = (products) => {
      return products.reduce(
        (accumulator, item) => {
          const quantity = Number(item.quantity) || 0;
          const mrp = Number(item.mrp) || 0;
          const offer = Number(item.offer_price) || 0;
          const dfee = Number(item.dfee) || 0;

          accumulator.total += quantity * mrp;
          accumulator.discountedTotal += quantity * (mrp - offer);
          accumulator.totalQuantity += quantity;
          accumulator.overweight_total += dfee > 0 ? dfee * quantity : 0; // Calculate overweight_total per quantity
          return accumulator;
        },
        { total: 0, discountedTotal: 0, totalQuantity: 0, overweight_total: 0 }
      );
    };

    if (!product) {
      toast.error('Product information is unavailable.');
      return;
    }

    if (product?.pro_var?.length > 0) {
      const updatedCart = cloneCart();

      selectedVariations.forEach((variation) => {
        const newProduct = {
          id: variation.id,
          image: variation.image,
          name: variation.name,
          brand: product.brand?.name || '',
          mrp: variation.mrp,
          offer_price: variation.offer_price,
          stock_status: variation.stock_status,
          cod_status: variation.cod_status,
          quantity: variation.quantity,
          dfee: variation.dfee || 0, // Add dfee for overweight calculation
        };

        const existingProductIndex = updatedCart.products.findIndex(
          (item) => String(item.id) === String(variation.id)
        );

        if (existingProductIndex !== -1) {
          const existingProduct = updatedCart.products[existingProductIndex];
          const existingQuantity = Number(existingProduct.quantity) || 0;
          const additionalQuantity = Number(variation.quantity) || 0;

          updatedCart.products[existingProductIndex] = {
            ...existingProduct,
            quantity: existingQuantity + additionalQuantity,
          };
        } else {
          updatedCart.products.push(newProduct);
        }
      });

      const totals = calculateTotals(updatedCart.products);
      updatedCart.total = totals.total;
      updatedCart.discountedTotal = totals.discountedTotal;
      updatedCart.totalQuantity = totals.totalQuantity;
      updatedCart.totalProducts = updatedCart.products.length;
      updatedCart.user_id = userId;
      updatedCart.overweight_total = totals.overweight_total; // Overweight charges are applied per quantity

      dispatch(updateCart(updatedCart))
        .unwrap()
        .then((res) => {
          toast.success('Selected variations added to cart!');
          console.log('Cart updated with variations:', res);
        })
        .catch((err) => {
          toast.error('Failed to add variations to cart.');
          console.error('Error:', err);
        });
    } else if (product && userId) {
      const updatedCart = cloneCart();

      const newProduct = {
        id: product.id,
        image: product.thumbnail,
        name: product.title,
        brand: product.brand?.name || '',
        mrp: product.regular_price,
        offer_price: product.sale_price,
        stock_status: product.stock_status,
        cod_status: product.codchk,
        quantity: selectedQuantity,
        dfee: product.dfee || 0, // Add dfee for overweight calculation
      };

      const existingProductIndex = updatedCart.products.findIndex(
        (item) => String(item.id) === String(product.id)
      );

      if (existingProductIndex !== -1) {
        const existingProduct = updatedCart.products[existingProductIndex];
        const existingQuantity = Number(existingProduct.quantity) || 0;

        updatedCart.products[existingProductIndex] = {
          ...existingProduct,
          quantity: existingQuantity + (Number(selectedQuantity) || 0),
        };
      } else {
        updatedCart.products.push(newProduct);
      }

      const totals = calculateTotals(updatedCart.products);
      updatedCart.total = totals.total;
      updatedCart.discountedTotal = totals.discountedTotal;
      updatedCart.totalQuantity = totals.totalQuantity;
      updatedCart.totalProducts = updatedCart.products.length;
      updatedCart.user_id = userId;
      updatedCart.overweight_total = totals.overweight_total; // Overweight charges are applied per quantity

      dispatch(updateCart(updatedCart))
        .unwrap()
        .then((res) => {
          toast.success('Product added to cart!');
          console.log('Cart updated:', res);
        })
        .catch((err) => {
          toast.error('Failed to update product in cart.');
          console.error('Error:', err);
        });
    } else {
      toast.error('Unable to add product to cart.');
      console.error('Missing product or userId.');
    }
  };


  const handleBuyNow = () => {
    handleAddToCart();
    navigate('/cart');
  };

  const handleFavouriteToggle = () => {
    if (!userDetails?.id) {
      navigate('/login');
      return;
    }

    const isFavourite = favouriteIds.includes(product.id);

    if (isFavourite) {
      dispatch(removeFavourite(product.id))
        .unwrap()
        .then(() => {
          toast.info('Removed from favourites!');
          dispatch(listFavouriteIds()); // Refresh favourite IDs
        })
        .catch((err) => {
          toast.error('Failed to remove from favourites.');
          console.error('Error:', err);
        });
    } else {
      dispatch(addFavourite(product.id))
        .unwrap()
        .then(() => {
          toast.success('Added to favourites!');
          dispatch(listFavouriteIds()); // Refresh favourite IDs
        })
        .catch((err) => {
          toast.error('Failed to add to favourites.');
          console.error('Error:', err);
        });
    }
  };



  if (loader) { // Show loading indicator while fetching
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="loader">loading...</div>
      </div>
    );
  }

  if (errors) { // Display errors if any
    return <div>Error: {errors}</div>;
  }

  return (

    <div className={styles.wrapper}>
      <div className={'BreadCrumb'}>
        <Link to={'/'} className={'BreadCrumbLink_breadCrumb'}>Home</Link>
        <Link to={'/'} className={'BreadCrumbLink_breadCrumb'}>Category</Link>
        <Link to={'/'} className={'BreadCrumbLink_breadCrumb'}>{product.title}</Link>
      </div>

      <div className={styles.Content_container}>
        <div className={styles.LHS_container}>
          <div className={styles.ProductUnit}>
            <div className={styles.ImgGallery}>
              <Gallery images={product.gallery} thumbnail={product.thumbnail} title={product.title} slug={product.slug}  />
            </div>
            <div className={styles.OverviewSection_mainContainer}>
              <div className={styles.OverviewSection}>
                <div className={styles.OverviewSection_nameContainer}>
                  <h1 className={styles.OverviewSection_productName} title={product.title}>{product.title}</h1>
                </div>
                <div className={styles.OverviewSection_productBrand}>
                  <Link to={``} className={styles.OverviewSection_brandLink}>Visit {product.brand?.name} Store</Link>
                </div>
                {lowestPrice !== null ? (
                  <div className={styles.ProductPriceContainer_productPriceWrapper}>
                    <div className={styles.ProductPriceContainer_originalMrp} style={{ marginLeft: 0 }}>Starting @</div>
                    <div className={styles.ProductPriceContainer_mrp}>&nbsp;₹{lowestPrice}/-</div>
                  </div>
                ) :  product.sale_price ? (
                  <>
                  <div className={styles.ProductPriceContainer_productPriceWrapper}>
                    <div className={styles.ProductPriceContainer_mrp}>{product.sale_price}</div>
                    <div className={styles.ProductPriceContainer_priceDiscountWrapper}>
                      <div className={styles.ProductPriceContainer_originalMrp}>
                        MRP <span className={styles.ProductPriceContainer_striked}>₹{product.regular_price}</span>
                      </div>
                      <div className={styles.ProductPriceContainer_discountContainer}>
                        {discount.toFixed(0)}% OFF
                      </div>
                    </div>
                  </div>
                  <div className={styles.ProductPriceContainer_inclusiveText}>Inclusive of all taxes</div>
                  </>
                ) : ( <h1 style={styles.MRP}>₹{product.regular_price}</h1> )}
                <div className={styles.OverviewSection_dispatchWrapper}>
                  Dispatch time: | 1-2 working days
                </div>

                {/* Qty trigger */}
                {product.sale_price ? (
                  <div className={styles.OverviewSection_statusWrapper}>
                    {product.stock_status === "In stock" ? 
                      <QuantitySelector 
                        initialQuantity={1} 
                        min={1} 
                        max={10} 
                        onChange={handleQuantityChange}
                      /> 
                    : <button style={{ marginTop: 20, width: 150 }} title="Out of Stock" variant="outofstock">Out of stock</button> }
                  </div>
                ) : null}

              </div>
              <div className={styles.OverviewSection_VariationUnit}>
                  {product?.pro_var?.length > 0 ? (
                  <Variations
                    status={product.stock_status}
                    products={product.pro_var}
                    addHere={addVariationToSelected}
                    length={variationLengh}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.RHS_container}>
          <PDPCartHandle
            status={product.stock_status}
            AddToCart={handleAddToCart}
            BuyNow={handleBuyNow}
            hasVariations={product?.pro_var?.length > 0 ? true : false}
            selectedVariations={selectedVariations}
            navigate={navigate}
            productId={product.id}
            isFavourite={favouriteIds.includes(product.id)}
            handleFavouriteToggle={handleFavouriteToggle}
            isPriceRequestEnabled={Boolean(product?.is_price_request_enabled)}
            onPriceRequestClick={() => setIsPriceRequestOpen(true)}
          />

        </div>
      </div>

  {/* Product Tabs: Interactive card-style tabs */}
                {Array.isArray(product.product_tabs) && product.product_tabs.length > 0 && (
                  <div className={styles.ProductTabsContainer}>
                    <div className={styles.ProductTabsHeader}>
                      {product.product_tabs.map((tab, idx) => (
                        <button
                          key={idx}
                          className={
                            `${styles.ProductTabButton} ${activeTab === idx ? styles.active : ''}`
                          }
                          onClick={() => setActiveTab(idx)}
                        >
                          {tab.title}
                        </button>
                      ))}
                    </div>
                    <div className={styles.ProductTabCard}>
                      <h3 className={styles.ProductTabTitle}>{product.product_tabs[activeTab].title}</h3>
                      <div
                        className={styles.ProductTabDescription}
                        dangerouslySetInnerHTML={{ __html: product.product_tabs[activeTab].description }}
                      />
                    </div>
                  </div>
                )}

      {/* Related Products Section */}
      {product.related && product.related.length > 0 && (
        <div className={styles.RelatedProductsSection}>
          <h2 className={styles.RelatedProductsTitle}>Related Products</h2>
          <div className={styles.RelatedProductsGrid}>
            {product.related.map((relatedProduct) => (
              <ProductCard key={relatedProduct.id} product={relatedProduct} showPrice={true} />
            ))}
          </div>
        </div>
      )}

      <PriceRequestModal
        isOpen={isPriceRequestOpen}
        onClose={() => setIsPriceRequestOpen(false)}
        product={product}
        userDetails={userDetails}
        token={token}
      />
    </div>
  );
};

export default ProductDetails;









const PDPCartHandle = ({ status, AddToCart, BuyNow, hasVariations, selectedVariations, navigate, productId, isFavourite, handleFavouriteToggle, isPriceRequestEnabled, onPriceRequestClick }) => {
  const { token, userDetails } = useSelector((state) => state.user);

  // Check for variation selection
  const validateVariations = () => {
    if (hasVariations && (!selectedVariations || selectedVariations.length === 0)) {
      toast.info('Please select a variation and quantity before proceeding.');
      return false;
    }
    return true;
  };

  // Common handler to check authentication
  const requireAuthentication = (callback) => {
    if (!token || !userDetails?.id) {
      navigate('/login');
    } else {
      callback();
    }
  };

  const handleAddToCart = () => {
    requireAuthentication(() => {
      if (validateVariations()) {
        AddToCart();
      }
    });
  };

  const handleBuyNow = () => {
    requireAuthentication(() => {
      if (validateVariations()) {
        BuyNow();
      }
    });
  };

  return (
    <div className={styles.PDPActionsContainer}>
      <button onClick={handleFavouriteToggle} className={`${styles.ActionButton_fill} ${styles.ActionButton_outline}`}>
        <span>{isFavourite ? 'Remove from Favourites' : 'Add to Favourites'}</span>
      </button>
      {status === "In stock" ? (
        <>
          <button onClick={handleAddToCart} className={`${styles.ActionButton_fill} ${styles.ActionButton_outline}`}>
            <span>Add to Cart</span>
          </button>
          <button onClick={handleBuyNow} className={styles.ActionButton_fill}>
            <span>Buy now</span>
          </button>
        </>
      ) : (
        <button className={`${styles.ActionButton_fill} ${styles.ActionButton_disabled}`} disabled>
          <span>Out of Stock</span>
        </button>
      )}
      {isPriceRequestEnabled && (
        <button onClick={onPriceRequestClick} className={styles.ActionButton_fill}>
          <span>Request Price</span>
        </button>
      )}
    </div>
  )
}




const PriceRequestModal = ({ isOpen, onClose, product, userDetails, token }) => {
  const [formValues, setFormValues] = useState({ name: '', email: '' });
  const [submitting, setSubmitting] = useState(false);

  const fallbackImage = 'https://images.dentalstores.in/storage/default-product.png';
  const firstGalleryItem = Array.isArray(product?.gallery) ? product.gallery[0] : product?.gallery || null;
  let galleryImageUrl = '';

  if (typeof firstGalleryItem === 'string') {
    galleryImageUrl = firstGalleryItem;
  } else if (firstGalleryItem && typeof firstGalleryItem === 'object') {
    galleryImageUrl = firstGalleryItem.image || firstGalleryItem.thumbnail || '';
  }

  const productImage = product?.thumbnail || galleryImageUrl || product?.image || product?.featured_image || '';
  const productName = product?.title || 'Selected Product';
  const brandName = product?.brand?.name;

  useEffect(() => {
    if (isOpen) {
      setFormValues({
        name: userDetails?.name || userDetails?.full_name || '',
        email: userDetails?.email || '',
      });
      setSubmitting(false);
    }
  }, [isOpen, userDetails]);

  if (!isOpen) {
    return null;
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const extractErrorMessage = (errorResponse) => {
    if (!errorResponse) {
      return null;
    }
    if (typeof errorResponse === 'string') {
      return errorResponse;
    }
    if (errorResponse.errors) {
      const firstFieldErrors = Object.values(errorResponse.errors)[0];
      if (Array.isArray(firstFieldErrors) && firstFieldErrors.length > 0) {
        return firstFieldErrors[0];
      }
    }
    if (errorResponse.message) {
      return errorResponse.message;
    }
    return null;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedName = formValues.name.trim();
    const trimmedEmail = formValues.email.trim();

    if (!trimmedName || !trimmedEmail) {
      toast.error('Please provide both name and email.');
      return;
    }

    if (!product?.id) {
      toast.error('Product information is unavailable.');
      return;
    }

    try {
      setSubmitting(true);
      const requestConfig = token
        ? { headers: { Authorization: `Bearer ${token}` } }
        : {};

      const productIdentifier = product?.title ? String(product.title) : String(product.id);

      await axios.post(
        `${OLD_API_BASE_URL}/price-request`,
        {
          name: trimmedName,
          email: trimmedEmail,
          product_id: productIdentifier,
        },
        requestConfig,
      );
      toast.success('Price request submitted successfully.');
      setSubmitting(false);
      onClose();
    } catch (error) {
      const message = extractErrorMessage(error.response?.data) || 'Unable to submit price request right now.';
      toast.error(message);
      setSubmitting(false);
    }
  };

  return (
    <div className={`modal-overlay ${styles.PriceRequestOverlay}`} onClick={onClose}>
      <div className={`modal-content ${styles.PriceRequestContent}`} onClick={(event) => event.stopPropagation()}>
        <button className={styles.PriceRequestClose} onClick={onClose} type="button" aria-label="Close">
          &times;
        </button>
        <div className={styles.PriceRequestHeader}>
          <span className={styles.PriceRequestBadge}>Exclusive Support</span>
          <h2 className={styles.PriceRequestTitle}>Request Price</h2>
          <p className={styles.PriceRequestSubtitle}>Share your details and our specialists will tailor the best quote for you.</p>
        </div>
        <div className={styles.PriceRequestProduct}>
        
          <div className={styles.PriceRequestMeta}>
            <h3 className={styles.PriceRequestProductName}>{productName}</h3>
            {brandName ? <p className={styles.PriceRequestProductBrand}>by {brandName}</p> : null}
            <ul className={styles.PriceRequestHighlights}>
              <li>Dedicated assistance from our team</li>
              <li>Personalised pricing for bulk or recurring orders</li>
            </ul>
          </div>
        </div>
        <form onSubmit={handleSubmit} className={styles.PriceRequestForm}>
          <label className={styles.PriceRequestLabel} htmlFor="priceRequestName">Full Name</label>
          <input
            id="priceRequestName"
            name="name"
            type="text"
            className={styles.PriceRequestInput}
            value={formValues.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            disabled={submitting}
            required
          />

          <label className={styles.PriceRequestLabel} htmlFor="priceRequestEmail">Email Address</label>
          <input
            id="priceRequestEmail"
            name="email"
            type="email"
            className={styles.PriceRequestInput}
            value={formValues.email}
            onChange={handleChange}
            placeholder="Enter your email"
            disabled={submitting}
            required
          />

          <button type="submit" className={styles.PriceRequestSubmit} disabled={submitting}>
            <span>{submitting ? 'Submitting...' : 'Submit Request'}</span>
          </button>
        </form>
        <p className={styles.PriceRequestFootnote}>We respond within 24 working hours. No charges until you confirm your order.</p>
      </div>
    </div>
  );
};



// Function to calculate the discount percentage
const getDiscountPercentage = (regularPrice, salePrice) => {
  if (regularPrice && salePrice && regularPrice > salePrice) {
    return ((regularPrice - salePrice) / regularPrice) * 100;
  }
  return 0;
};

// Function to get the lowest sale price from the pro_var array
const getLowestSalePrice = (pro_var) => {
  if (pro_var && pro_var.length > 0) {
    const prices = pro_var.map((variant) => parseFloat(variant.sale_price)); // Assuming the sale_price is in the "sale_price" field of each variant
    const lowestPrice = Math.min(...prices);
    return lowestPrice;
  }
  return null;
};


const QuantitySelector = ({ initialQuantity = 1, min = 1, max = 10, onChange }) => {
  const [quantity, setQuantity] = useState(initialQuantity);

  const handleIncrement = () => {
    if (quantity < max) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      if (onChange) onChange(newQuantity);
    }
  };

  const handleDecrement = () => {
    if (quantity > min) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      if (onChange) onChange(newQuantity);
    }
  };

  return (
    <div className={styles.quantitySelector}>
      <button onClick={handleDecrement} disabled={quantity === min} className={styles.quantityButton}>
        -
      </button>
      <span className={styles.quantityDisplay}>{quantity}</span>
      <button onClick={handleIncrement} disabled={quantity === max} className={styles.quantityButton}>
        +
      </button>
    </div>
  );
};

// Variation quantity trigger
const VariationQuantitySelector = ({ addVariationToSelected, current }) => {
  const [quantity, setQuantity] = useState(0);

  const newProduct = {
    id: current.id,
    image: current.thumbnail,
    name: current.variation_desc,
    mrp: current.regular_price,
    offer_price: current.sale_price,
    stock_status: current.stock_status,
    cod_status: current.codchk,
    quantity: quantity, // The quantity from the state
  };

  useEffect(() => {
    if (quantity !== 0) {
      addVariationToSelected(newProduct);
      console.log("Product added/updated in selected variations:", newProduct);
    }
  }, [quantity]); // Only update when quantity changes

  const increment = () => setQuantity((prev) => prev + 1);

  const decrement = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    } else {
      setQuantity(0); // Reset to 0 when decremented from 1
    }
  };

  return (
    <div>
      {quantity === 0 ? (
        <button onClick={increment} className={styles.quantityButton}>
          Add
        </button>
      ) : (
        <div className={styles.quantitySelector}>
          <button onClick={decrement} className={styles.quantityButton}>-</button>
          <span className={styles.quantityDisplay}>{quantity}</span>
          <button onClick={increment} className={styles.quantityButton}>+</button>
        </div>
      )}
    </div>
  );
};


const Variations = ({ products, status, addHere }) => {
  const getDiscountPercentage = (regularPrice, salePrice) => {
    return ((regularPrice - salePrice) / regularPrice) * 100;
  };

  return (
    <div>
      {products.map((product, index) => {
        const discount = getDiscountPercentage(product.regular_price, product.sale_price);

        return (
          <div className={styles.ProductVariationItemWrapper} key={index}>
            <div className={styles.ProductVariationItemTitle}>{product.variation_desc}</div>
            <div className={styles.ProductPriceContainer_productPriceWrapper}>
              <div className={styles.ProductPriceContainer_mrp}>{product.sale_price}</div>
              <div className={styles.ProductPriceContainer_priceDiscountWrapper}>
                <div className={styles.ProductPriceContainer_originalMrp}>
                  MRP <span className={styles.ProductPriceContainer_striked}>₹{product.regular_price}</span>
                </div>
                <div className={styles.ProductPriceContainer_discountContainer}>
                  {discount.toFixed(0)}% OFF
                </div>
              </div>
            </div>
            <div className={styles.ProductPriceContainer_inclusiveText}>Inclusive of all taxes</div>
            {status !== "In stock" ? (
              <button 
                style={{ marginTop: 20, width: 150 }} 
                title="Out of Stock" 
                disabled
              >
                Out of Stock
              </button>
            ) : (
              <div style={{ marginTop: 10 }}>
                {product.stock_status === "In stock" ? 
                  <VariationQuantitySelector 
                    addVariationToSelected={addHere}
                    current={product}
                  /> : 
                  <button 
                    style={{ marginTop: 20, width: 150 }} 
                    title="Out of Stock" 
                    disabled
                  >
                    Out of Stock
                  </button>
                }
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};



